<template>
  <div>
    <el-dialog
      class="dialog-treaty"
      title="会员协议"
      :visible="visible"
      append-to-body
      @close="onConfirm"
      width="800px"
    >
      <div class="content">
        <div class="title">会员协议</div>
        <el-scrollbar ref="scroll" id="treaty-content">
          <Rich v-html="treatyContent"></Rich>
        </el-scrollbar>
      </div>
      <template v-slot:footer>
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TreatyModal",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    showModal(value) {
      this.visible = value;
    },
  },
  computed: {
    //会员协议内容
    treatyContent() {
      return this.$store.state.commonSetting.treaty_content || "";
    },
  },
  methods: {
    onConfirm() {
      this.visible = false;
      this.$emit("update:showModal", false);
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-treaty {
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 16px 24px 0 24px;
    height: 500px !important;
    max-height: none;
  }
  .content {
    .title {
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #333333;
      line-height: 24px;
      margin-bottom: 16px;
    }
    /deep/ {
      .el-scrollbar__wrap {
        //border-radius: 5px;
        overflow-x: hidden;
      }
    }
    #treaty-content {
      height: 460px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      & {
        -ms-overflow-style: none;
      }
      & {
        overflow: -moz-scrollbars-none;
      }
    }
  }
  /deep/ .el-dialog__footer {
    padding: 24px;
  }
}
</style>
